import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { a as r } from "../../../../index-CROKJrb5.js";
import { c as n, f as d } from "../../../../create-component-CBAeEoQ6.js";
import { CardImage as l } from "../../CardImage/index.js";
import { Label as s } from "../../../Label/index.js";
const N = n(
  "BeforeAfterCardImages",
  d(
    ({
      afterProps: {
        label: f = /* @__PURE__ */ e.jsx(s, { labelType: "beforeAfter", children: "After" }),
        className: o,
        ...m
      } = {},
      aspectRatio: a = "3:4",
      beforeProps: {
        label: t = /* @__PURE__ */ e.jsx(s, { labelType: "beforeAfter", children: "Before" }),
        className: c,
        ...i
      } = {},
      className: p,
      ...x
    }, b) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        ...x,
        className: r("cur-flex cur-gap-[.125rem]", p),
        ref: b,
        children: [
          /* @__PURE__ */ e.jsx(
            l,
            {
              ...i,
              className: r("cur-flex-1", c),
              label: t,
              aspectRatio: a
            }
          ),
          /* @__PURE__ */ e.jsx(
            l,
            {
              ...m,
              className: r("cur-flex-1", o),
              label: f,
              labelAlign: "right",
              aspectRatio: a
            }
          )
        ]
      }
    )
  )
);
export {
  N as BeforeAfterCardImages
};
//# sourceMappingURL=index.js.map
